import { render, staticRenderFns } from "./ProductEditorImages.vue?vue&type=template&id=1b069b4d&scoped=true&"
import script from "./ProductEditorImages.vue?vue&type=script&lang=js&"
export * from "./ProductEditorImages.vue?vue&type=script&lang=js&"
import style0 from "./ProductEditorImages.vue?vue&type=style&index=0&id=1b069b4d&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b069b4d",
  null
  
)

export default component.exports